/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstalledApplicationDto } from './InstalledApplicationDto';
import {
    InstalledApplicationDtoFromJSON,
    InstalledApplicationDtoFromJSONTyped,
    InstalledApplicationDtoToJSON,
    InstalledApplicationDtoToJSONTyped,
} from './InstalledApplicationDto';
import type { OpenVulnCountSnapshot } from './OpenVulnCountSnapshot';
import {
    OpenVulnCountSnapshotFromJSON,
    OpenVulnCountSnapshotFromJSONTyped,
    OpenVulnCountSnapshotToJSON,
    OpenVulnCountSnapshotToJSONTyped,
} from './OpenVulnCountSnapshot';
import type { RelatedOpenCaseDto } from './RelatedOpenCaseDto';
import {
    RelatedOpenCaseDtoFromJSON,
    RelatedOpenCaseDtoFromJSONTyped,
    RelatedOpenCaseDtoToJSON,
    RelatedOpenCaseDtoToJSONTyped,
} from './RelatedOpenCaseDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { OpenWeaknessCountSnapshot } from './OpenWeaknessCountSnapshot';
import {
    OpenWeaknessCountSnapshotFromJSON,
    OpenWeaknessCountSnapshotFromJSONTyped,
    OpenWeaknessCountSnapshotToJSON,
    OpenWeaknessCountSnapshotToJSONTyped,
} from './OpenWeaknessCountSnapshot';

/**
 * Asset golden inventory detail with security rollups and observation backlog
 * @export
 * @interface AssetInventoryDetailResponse
 */
export interface AssetInventoryDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDetailResponse
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDetailResponse
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDetailResponse
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDetailResponse
     */
    fqdn?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDetailResponse
     */
    hardwareUuid?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    openVulnInstanceCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    materializedOpenVulnCount?: number;
    /**
     * 
     * @type {OpenVulnCountSnapshot}
     * @memberof AssetInventoryDetailResponse
     */
    materializedVulnSeverityBreakdown?: OpenVulnCountSnapshot;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    materializedOpenWeaknessCount?: number;
    /**
     * 
     * @type {OpenWeaknessCountSnapshot}
     * @memberof AssetInventoryDetailResponse
     */
    materializedWeaknessSeverityBreakdown?: OpenWeaknessCountSnapshot;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    openComplianceFailCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    vulnScannerSourceCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetInventoryDetailResponse
     */
    vulnScannerSources?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    observationBacklogPending?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    installedApplicationCount?: number;
    /**
     * 
     * @type {Array<InstalledApplicationDto>}
     * @memberof AssetInventoryDetailResponse
     */
    installedApplications?: Array<InstalledApplicationDto>;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    relatedOpenCaseCount?: number;
    /**
     * 
     * @type {Array<RelatedOpenCaseDto>}
     * @memberof AssetInventoryDetailResponse
     */
    relatedOpenCases?: Array<RelatedOpenCaseDto>;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDetailResponse
     */
    queryDurationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDetailResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof AssetInventoryDetailResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof AssetInventoryDetailResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof AssetInventoryDetailResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the AssetInventoryDetailResponse interface.
 */
export function instanceOfAssetInventoryDetailResponse(value: object): value is AssetInventoryDetailResponse {
    return true;
}

export function AssetInventoryDetailResponseFromJSON(json: any): AssetInventoryDetailResponse {
    return AssetInventoryDetailResponseFromJSONTyped(json, false);
}

export function AssetInventoryDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInventoryDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'fqdn': json['fqdn'] == null ? undefined : json['fqdn'],
        'hardwareUuid': json['hardwareUuid'] == null ? undefined : json['hardwareUuid'],
        'openVulnInstanceCount': json['openVulnInstanceCount'] == null ? undefined : json['openVulnInstanceCount'],
        'materializedOpenVulnCount': json['materializedOpenVulnCount'] == null ? undefined : json['materializedOpenVulnCount'],
        'materializedVulnSeverityBreakdown': json['materializedVulnSeverityBreakdown'] == null ? undefined : OpenVulnCountSnapshotFromJSON(json['materializedVulnSeverityBreakdown']),
        'materializedOpenWeaknessCount': json['materializedOpenWeaknessCount'] == null ? undefined : json['materializedOpenWeaknessCount'],
        'materializedWeaknessSeverityBreakdown': json['materializedWeaknessSeverityBreakdown'] == null ? undefined : OpenWeaknessCountSnapshotFromJSON(json['materializedWeaknessSeverityBreakdown']),
        'openComplianceFailCount': json['openComplianceFailCount'] == null ? undefined : json['openComplianceFailCount'],
        'vulnScannerSourceCount': json['vulnScannerSourceCount'] == null ? undefined : json['vulnScannerSourceCount'],
        'vulnScannerSources': json['vulnScannerSources'] == null ? undefined : json['vulnScannerSources'],
        'observationBacklogPending': json['observationBacklogPending'] == null ? undefined : json['observationBacklogPending'],
        'installedApplicationCount': json['installedApplicationCount'] == null ? undefined : json['installedApplicationCount'],
        'installedApplications': json['installedApplications'] == null ? undefined : ((json['installedApplications'] as Array<any>).map(InstalledApplicationDtoFromJSON)),
        'relatedOpenCaseCount': json['relatedOpenCaseCount'] == null ? undefined : json['relatedOpenCaseCount'],
        'relatedOpenCases': json['relatedOpenCases'] == null ? undefined : ((json['relatedOpenCases'] as Array<any>).map(RelatedOpenCaseDtoFromJSON)),
        'queryDurationMs': json['queryDurationMs'] == null ? undefined : json['queryDurationMs'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function AssetInventoryDetailResponseToJSON(json: any): AssetInventoryDetailResponse {
    return AssetInventoryDetailResponseToJSONTyped(json, false);
}

export function AssetInventoryDetailResponseToJSONTyped(value?: AssetInventoryDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'hostname': value['hostname'],
        'fqdn': value['fqdn'],
        'hardwareUuid': value['hardwareUuid'],
        'openVulnInstanceCount': value['openVulnInstanceCount'],
        'materializedOpenVulnCount': value['materializedOpenVulnCount'],
        'materializedVulnSeverityBreakdown': OpenVulnCountSnapshotToJSON(value['materializedVulnSeverityBreakdown']),
        'materializedOpenWeaknessCount': value['materializedOpenWeaknessCount'],
        'materializedWeaknessSeverityBreakdown': OpenWeaknessCountSnapshotToJSON(value['materializedWeaknessSeverityBreakdown']),
        'openComplianceFailCount': value['openComplianceFailCount'],
        'vulnScannerSourceCount': value['vulnScannerSourceCount'],
        'vulnScannerSources': value['vulnScannerSources'],
        'observationBacklogPending': value['observationBacklogPending'],
        'installedApplicationCount': value['installedApplicationCount'],
        'installedApplications': value['installedApplications'] == null ? undefined : ((value['installedApplications'] as Array<any>).map(InstalledApplicationDtoToJSON)),
        'relatedOpenCaseCount': value['relatedOpenCaseCount'],
        'relatedOpenCases': value['relatedOpenCases'] == null ? undefined : ((value['relatedOpenCases'] as Array<any>).map(RelatedOpenCaseDtoToJSON)),
        'queryDurationMs': value['queryDurationMs'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

